import { Directive } from "vue"

interface ClickOutsideBinding {
  handler: (event: Event) => void
  exclude?: HTMLElement | null
}

export const clickOutside: Directive = {
  beforeMount(el, binding) {
    el.__clickOutsideHandler__ = (event: Event) => {
      const { handler, exclude } = binding.value as ClickOutsideBinding

      if (
        typeof handler === "function" &&
        !el.contains(event.target as Node) &&
        !exclude?.contains(event.target as Node)
      ) {
        handler(event)
      }
    }
    document.addEventListener("click", el.__clickOutsideHandler__)
  },
  unmounted(el) {
    document.removeEventListener("click", el.__clickOutsideHandler__)
    delete el.__clickOutsideHandler__
  },
}
